import React, {useState} from 'react';

export function SubmittedSignature({value, label = 'Customer signature'}) {
    const [failed,setFailed]=useState(false);
    if(typeof value !== 'string' || !value.trim())return <span>Not recorded</span>;
    const image=/^data:image\/(png|jpe?g|webp);base64,/i.test(value);
    if(image)return failed ? <span role="status">Signature image could not be displayed.</span> :
        <img alt={label} src={value} onError={()=>setFailed(true)} className="max-h-40 max-w-full bg-white rounded-md p-2"/>;
    if(value.startsWith('data:'))return <span role="status">Signature format could not be displayed.</span>;
    // The navy-card theme overrides .text-navy to white. Signature paper needs
    // an explicit ink colour independent of the surrounding card theme.
    return <div data-testid="typed-signature" style={{color:'#101a3a', backgroundColor:'#ffffff'}} className="rounded-md p-3 break-words"><span className="block text-xs mb-1">Typed signature</span><span className="font-serif text-xl">{value}</span></div>;
}
